var image_to_cart = ""
$(document).on('click', '.product button', function() {
  image_to_cart = $(this).closest('.p').find('.image img').attr('src').trim().replace('/big/', '/detail/')
});
$(document).on('ShoptetDOMAdvancedOrderLoaded', function() {    
   if($('.type-detail').length){
    if($('.p-image a').attr('href') === '/cms/img/common/missing_images/big.png'){
      $('.advanced-order .h2:not(".advanced-order-suggestion")').prepend('<img src="/cms/img/common/missing_images/big.png">')
    }
    else{
      $('.advanced-order .h2:not(".advanced-order-suggestion")').prepend('<img src="'+$('.p-image #wrap a').attr('href').replace('/big/', '/detail/')+'">')
    }
    
   } 
   else{
    $('.advanced-order .h2:not(".advanced-order-suggestion")').prepend('<img src="'+image_to_cart+'">')
   }
    $("<div class='extra back-wrap step'><span class='btn btn-secondary' onclick='shoptet.modal.close();'>Zpět do obchodu</span></div>").prependTo(".advanced-order .extras-wrap");
    const DestroyProductSlider = (function() {
        function destroySlider($el) {
          $el.removeAttr("style");
          $el.removeClass("product-slider").addClass("products-block");
          $el.find(".product").removeAttr("style").appendTo($el);
          $el.find(".products-block").remove();
          const $frame = $el.parent();
          $frame.removeClass("product-slider-holder has-navigation slide-active");
          $frame.find(".product-slider-pagination,.product-slider-navigation").remove();
          $frame.replaceWith($frame.clone(false)); // remove event handlers and break references
        }
        const init = tb.dom.createModuleInitializer({
          earlyInit() {
            tb.dom.$each($(".advanced-order .product-slider"), destroySlider);
          }
        });
        return { init };
      })();
      DestroyProductSlider.init();
      $('.advanced-order .products').slick({
        slidesToShow: 4,
       slidesToScroll: 4,
       autoplay: false,
       autoplaySpeed: 3000,
       dots: false,
       arrow: true,
       infinite: false,
       responsive: [
      {
           breakpoint: 1440,
           settings: {
             slidesToShow: 4,
             slidesToScroll: 4,
           }
         },
         {
           breakpoint: 1199,
           settings: {
             slidesToShow: 3,
             slidesToScroll: 3,
           }
         },
         
         {
           breakpoint: 991,
           settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
         },
         {
           breakpoint: 330,
           settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
         }
       ]
      });

    setTimeout(function(){
        shoptet.modal.shoptetResize();
    }, 100) 
})

if($('.id--9').length){
    $('.removeable').each(function(){
        $(this).find('.p-total').prepend('<div class="mobile-ks">'+$(this).find('.p-price').html()+'</div>')
    })
    document.addEventListener('ShoptetDOMCartContentLoaded', function() {
        $('.removeable').each(function(){
            $(this).find('.p-total').prepend('<div class="mobile-ks">'+$(this).find('.p-price').html()+'</div>')
        })
    });
}

if($('.id--15').length){
    $('tr[data-testid="recapItem"]').each(function(){
        $(this).find('.p-total').prepend('<div class="mobile-ks">'+$(this).find('.p-price').html()+'</div>')
    })
}

if($('.id--16, .id--17').length){
  $('.checkout-box .contact-box').prepend('<div class="top"><img src="'+$('.checkout-box .contact-box img').attr('src')+'"><div class="h2">Potřebujete poradit?</div></div>')
    //shoptet.cart.getCartContent();
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){        
        $('.order-summary-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            availability = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .p-availability').html()
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
            $(this).find('.cart-item-name').after('<div class="avail">'+availability+'</div>')
        })
    })
}
